import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import ErrorBox from "../custom_components/ErrorBox"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
// core components
import Header from "./../custom_components/Header"
import Footer from "../components/Footer/Footer";
import Sidebar from "./../custom_components/Sidebar";

import dashboardRoutes from "../routes/dashboard";
import * as types from '../types'
//mport appStyle from "../assets/jss/material-dashboard-pro-react/layouts/dashboardStyle";

import image from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/logo-white.svg";
import {Track} from '../data/track/track';
import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid
} from "src/assets/jss/material-dashboard-pro-react.jsx";

import Button from "../components/CustomButtons/Button"
import { ViewState } from "../types";
const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh",
    "&:after": {
      display: "table",
      clear: "both",
      content: '" "'
    }
  },
  mainPanel: {
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "70px",
    padding: "30px 15px",
    minHeight: "calc(100vh - 123px)"
  },
  container: { ...containerFluid },
  map: {
    marginTop: "70px"
  },
  mainPanelSidebarMini: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerMiniWidth}px)`
    }
  },
  mainPanelWithPerfectScrollbar: {
    overflow: "hidden !important"
  },
  progress: {
    margin: theme.spacing.unit * 2,
    width:100
  },
});


const switchRoutes = (
  <Switch>
    {dashboardRoutes.map((prop, key) => {
      if (prop.redirect)
        return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
      //@ts-ignore
      if (prop.collapse)
      //@ts-ignore
        return prop.views.map((prop, key) => {
          return (
            <Route path={prop.path} component={prop.component} key={key} />
          );
        });
      return <Route path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

var ps;
interface DashboardProps {
  classes: any;
  connect: types.IState
}
interface DashboardState {
  mobileOpen: boolean;
  miniActive: boolean;

}
class Dashboard extends React.Component<DashboardProps,DashboardState> {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: false
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      if(!this.refs.mainPanel)
      {
        return;
      }
      //@ts-ignore
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
       //@ts-ignore
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    //@ts-ignore
    return this.props.location.pathname !== "/maps/full-screen-maps";
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }
  lastRoute:any;
  render() {
   
    if (!this.props.connect.dispatch || !this.props.connect.lo_ctx || this.props.connect.lo_ctx.notLoaded() ||this.props.connect.lo_CustomerBalance.notLoaded() ||
    this.props.connect.lo_PodCasts.notLoaded() ) {
       return <div>Loading</div>;
    }
    
    if (window.location.pathname != this.lastRoute) {
      //debugger;
      Track.PageView(window.location.pathname);
      this.lastRoute = window.location.pathname;
    }
    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    let balanceButton = (<div></div>)
    if(false && this.props.connect.lo_CustomerBalance.completed())
    {
        balanceButton = ( <Button style={{
            position: 'absolute',
            right: '0px',
            top: '0px'
        
        }} color='primary' onClick={(e)=>{
            types.ViewState.navigate(types.ViewState.getDefaultHash(types.AppSection.Credits))
        }} simple>{this.props.connect.lo_CustomerBalance.val().credits} credit(s)</Button>)
    }
   
    if(this.props.connect.lo_ctx.error())
    {
        window.location.href = ViewState.getDefaultHash(types.AppSection.LogIn)
        /*setTimeout(()=>
          ViewState.navigate(ViewState.getDefaultHash(types.AppSection.LogIn)),
          1)*/
   
    }
   

    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={dashboardRoutes}
          logoText={"Cast a Blog"}
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          bgColor="black"
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={dashboardRoutes}
            balanceButton={balanceButton}
            handleDrawerToggle={this.handleDrawerToggle}

            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.props.connect.lo_ctx.completed() &&
            this.props.connect.lo_Tracks.completed() &&
            this.props.connect.lo_PodCasts.completed() &&
            this.props.connect.lo_CustomerBalance.completed() && (
            <div>
              {this.getRoute() ? (
                <div style={{paddingTop:'25px'}}>
                  <div className={classes.container}>{switchRoutes}</div>
                </div>
               
              ) : (
                <div className={classes.map}>{switchRoutes}</div>
              )}
              
              </div>
          )}
           {!this.props.connect.lo_ctx.completed() && (
                <CircularProgress className={classes.progress} />
           )}
           <ErrorBox showError={this.props.connect.errorState.showError}/>
          {this.getRoute() ? <Footer fluid /> : null}
        </div>
      </div>
    );
  }
}



export function mapStateToProps(state: types.IState) {
  return {
      connect: state
  };
}
export default connect(
  mapStateToProps,
  null
)(withStyles(appStyle as any)(Dashboard));






// WEBPACK FOOTER //
// ./src/layouts/MainDashboard.tsx